import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
// import Add from "./Add";
// import Edit from "./Edit";
import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { findAll } from "../../../utils/apis/teen_patti/bid_history_roomwise/bid_history_roomwise";

import {
  formatDateTime,
  Per_Page_Dropdown,
  users_type,
} from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import { Country, State, stores } from "../../../utils/apis/common/index";
import { formatDate } from "../../../utils/common";
import Select from "react-select";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";
import { useNavigate } from "react-router-dom";

const Tables = () => {
  const params = new URLSearchParams(window.location.search);

  const id = params.get("id");
  const from = params.get("from");
  const store_id = params.get("store_id");
  const only_win = params.get("only_win") === "true";
  const typeParam = params.get("type");

  const { UnauthorizedLogOut, Select2Data, IMG_URL, usertype } =
    useContext(Context);

  const today = new Date();

  const formattedDate =
    today.getFullYear().toString() +
    String(today.getMonth() + 1).padStart(2, "0") +
    String(today.getDate()).padStart(2, "0");

  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);

  const [data, setData] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(50);
  const [search, setSearch] = useState(formattedDate);
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [searchDateTo, setSearchDateTo] = useState("");

  const [name, setName] = useState("");
  const [contact_no, setContact_no] = useState("");
  const [store, setStore] = useState();

  const [searchDateFrom, setSearchDatefrom] = useState(from || "");
  const [onlyWin, setOnlyWin] = useState(only_win);
  const [type, setSearchType] = useState(typeParam || "");
  const [searchStore, setSearchStore] = useState(null);

  const getStores = async () => {
    const response = await stores();

    await setStore(response?.data?.data?.data);
  };

  const getDataAll = async () => {
    try {
      const response = await findAll(
        currentPage,
        perPage,
        searchDateFrom,
        searchStore?.value,
        name,
        contact_no,
        id,
        onlyWin,
        type,
      );

      await setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      // setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getStores();
  }, []);

  useEffect(() => {
    if (store) {
      getDataAll();
    }
  }, [store, currentPage, perPage, reset, modalShow, modalEditShow]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleDateChange = (date) => {
    setSearchDateTo(date); // Update the state with the selected date
  };

  const getToday = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDateForPeriod = (date) => date.replaceAll("-", "");

  const [periodPrefix, setPeriodPrefix] = useState(formattedDate);
  const [periodSuffix, setPeriodSuffix] = useState("");

  useEffect(() => {
    if (searchDateFrom) {
      setPeriodPrefix(formatDateForPeriod(searchDateFrom));
      setPeriodSuffix(""); // reset suffix when date changes
    }
  }, [searchDateFrom]);
  const sessionOptions = [
    { value: "", label: "Select Session" },
    { value: "open", label: "Open" },
    { value: "close", label: "Close" },
  ];

  useEffect(() => {
    if (store && store_id) {
      const selectedStore = store.find(
        (item) => String(item.value) === String(store_id),
      );

      setSearchStore(selectedStore || null);
    }
  }, [store, store_id]);

  const navigate = useNavigate();

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Teen Patti Bid History"} />
        <div className="search-bar-holder ">
          <Form>
            <div className="row align-items-end">
              {/* <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={searchDateFrom}
                    min="0001-01-01"
                    max="9999-12-31" // ✅ ensures only 4-digit year
                    onChange={(e) => {
                      const value = e.target?.value;

                      // optional safety (can even remove this) 77777777777777777
                      if (!value) return;

                      const year = value.split("-")[0];
                      if (year.length !== 4) return;

                      setSearchDatefrom(value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">User Name</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target?.value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">User Number</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Mobile Number"
                    value={contact_no}
                    onChange={(e) => {
                      setContact_no(e.target?.value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                <br></br>
                <Button
                  type="button"
                  className="search-btn mt-2"
                  onClick={getDataAll}>
                  Search
                </Button>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5   col-holder">
                <br></br>
                <Button
                  type="button"
                  className="reset-btn mt-2"
                  onClick={() => {
                    setName("");
                    setSearchDatefrom("");
                    setSearchStore("");
                    setContact_no("");
                    setOnlyWin(false);
                    setSearchType("");
                    setReset(!reset);
                  }}>
                  Reset
                </Button>
              </div> */}
              <hr />
            </div>
          </Form>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              {/* <Banner_List_Table /> */}

              <div className="data-table-holder">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Room Number</th>
                      <th>Joining Points</th>
                      <th>Total Rounds</th>
                      <th>Start Date</th>
                      <th>Start Time</th>
                      <th>View All Rounds</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.data?.data?.length > 0 ? (
                      data.data.data.map((d, index) => {
                        return (
                          <tr>
                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                            {/* <td>{index + 1}</td> */}
                            <td>{d?.id ?? "-"}</td>
                            <td>{d?.TeenPattiAmount?.amount ?? "-"} points</td>
                            <td>{d?.TeenPattiRounds?.length ?? "-"}</td>
                            <td>
                              {d?.TeenPattiRounds?.[0]?.createdAt
                                ? new Date(
                                    d.TeenPattiRounds?.[0]?.createdAt,
                                  ).toLocaleDateString("en-GB")
                                : "-"}
                            </td>
                            <td>
                              {new Date(
                                d.TeenPattiRounds?.[0]?.updatedAt,
                              ).toLocaleString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </td>
                            <td>
                              <Button
                                onClick={() =>
                                  navigate(
                                    `/teen-patti-history-inner-page?room_id=${d.id}`,
                                    // {
                                    //   state: {
                                    //     room_id: d?.id,
                                    //     history: d?.TeenPattiRounds,
                                    //   },
                                    // },
                                  )
                                }>
                                View
                              </Button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                <CustomPaginate
                  currentPage={data?.data?.current_page}
                  totalPages={data?.data?.total_pages}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Tables;
